import { NgModule } from '@angular/core';
import { AccountOwnerRoutingModule, ACCOUNT_OWNER_ROUTE_COMPONENTS  } from './account-owner-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AccountOwnerDetailsComponent } from './account-owner-details/account-owner-details.component';
import { AccountOwnerComponent } from './account-owner/account-owner.component';
import { EditCardComponent } from './payment-methods/edit-card/edit-card.component';
import { PaymentMethodsComponent } from './payment-methods/payment-methods.component';
import { FunctionsService } from '../../services/functions.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxStripeModule } from '@nomadreservations/ngx-stripe';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { CancelSubscriptionComponent } from './subscription-details/cancel-subscription/cancel-subscription.component';
import { UpdateLogoComponent } from './update-logo/update-logo.component';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { SubscriptionDetailsComponent } from './subscription-details/subscription-details.component';
import { ViewReceiptComponent } from './subscription-details/view-receipt/view-receipt.component';
import { SubscriptionPurchaseComponent } from './subscription-purchase/subscription-purchase.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { environment } from 'src/environments/environment';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ChangePlanProrateComponent } from './change-plan-prorate/change-plan-prorate.component';
import { ChangePlanOwnerComponent } from './change-plan-owner/change-plan-owner.component';
import { PaymentProcessedComponent } from './subscription-purchase/payment-processed/payment-processed.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AuthInterceptorProvider } from 'src/app/services/token/token-interceptor.service';

@NgModule({
    declarations: [
        ACCOUNT_OWNER_ROUTE_COMPONENTS,
        AccountOwnerComponent,
        AccountOwnerDetailsComponent,
        CancelSubscriptionComponent,
        ChangePlanOwnerComponent,
        ChangePlanProrateComponent,
        EditCardComponent,
        PaymentMethodsComponent,
        PaymentProcessedComponent,
        SubscriptionDetailsComponent,
        SubscriptionPurchaseComponent,
        UpdateLogoComponent,
        ViewReceiptComponent
    ],
    imports: [
        AccountOwnerRoutingModule,
        BreadcrumbModule,
        CommonModule,
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSortModule,
        NgbModule,
        NgxPermissionsModule,
        NgxSpinnerModule,
        NgxStripeModule.forRoot(environment.stripe_pk),
        ReactiveFormsModule,
        TranslateModule
    ],
    providers: [FunctionsService, AuthInterceptorProvider]
})
export class AccountOwnerModule {}